import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import {
  getLatestWalletActivationRequest,
  requestWalletActivation,
} from "../../utils/SonicAPIV2";

const EnableWalletRequest = () => {
  const [cooldown, setCooldown] = useState(0);
  const [cooldownHHMM, setCooldownHHMM] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(
    "Your Wallet is not active, kindly request to enable the Zulal Wallet."
  );
  const [isRequestActive, setIsRequestActive] = useState(false);

  useEffect(() => {
    const checkActivationRequest = async () => {
      try {
        const res = await getLatestWalletActivationRequest();
        // console.log("Latest wallet activation request response:", res);

        console.log(res.data.isRequestActive);

        if (res.data && res.data.isRequestActive) {
          setMessage(res.data.message);
          setCooldown(res.data.cooldownSecondsRemaining);
          setIsRequestActive(true);
          console.log("Latest wallet activation request response:");
        }
      } catch (e) {
        console.error("Error fetching latest wallet activation request:", e);
        toast.error("Failed to check wallet activation status");
      }
    };
    checkActivationRequest();
  }, []);

  // useEffect(() => {
  //   let timer;
  //   if (cooldown > 0) {
  //     timer = setInterval(() => setCooldown((c) => c - 1), 1000);
  //   }
  //   return () => clearInterval(timer);
  // }, [cooldown]);

  const handleRequest = async () => {
    setLoading(true);
    try {
      const res = await requestWalletActivation();
      setMessage(res.message);
      if (res.cooldownSecondsRemaining > 0) {
        setCooldown(res.cooldownSecondsRemaining);
        setCooldownHHMM(res.cooldownRemainingHHMM);
      } else {
        setCooldown(0);
        setCooldownHHMM("");
      }
      if (res.success) {
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    } catch (e) {
      if (e.response && e.response.status === 429 && e.response.data) {
        const res = e.response.data;
        setCooldown(res.cooldownSecondsRemaining);
        setCooldownHHMM(res.cooldownRemainingHHMM);
        setMessage(res.message);
        toast.error(res.message);
      } else {
        toast.error("Failed to submit activation request");
      }
    }
    setLoading(false);
  };

  return (
    <div className="mx-auto max-w-2xl mr-4 ml-4 mb-28 flex flex-col items-start justify-start mt-2 min-h-[300px]">
      <div className="text-navarbarText text-3xl font-poppins font-medium mb-8">
        Zulal Wallet
      </div>
      <p className="text-base text-textBlack font-poppins font-normal mb-6 text-center">
        {message}
      </p>
      {cooldown > 0 ? (
        <div className="text-red-600 font-semibold mb-4">
          Request already submitted.
          <br />
          Please wait{" "}
          {cooldownHHMM ||
            `${Math.floor(cooldown / 60)}:${(cooldown % 60)
              .toString()
              .padStart(2, "0")}`}{" "}
          hours before retrying.
        </div>
      ) : null}
      <button
        className={`px-6 py-2 rounded font-poppins font-medium transition
    ${
      loading || isRequestActive || cooldown > 0
        ? "bg-gray-400 text-gray-200 cursor-not-allowed opacity-60 border border-cool-gray-400 "
        : "bg-primary text-textWhite hover:bg-primaryHover hover:text-primary"
    }
  `}
        onClick={handleRequest}
        disabled={loading || isRequestActive || cooldown > 0}
      >
        {loading ? "Requesting..." : "Request to Enable Wallet"}
      </button>
    </div>
  );
};

export default EnableWalletRequest;
